export const TRACK_NOUN = 'Track'
export const ARTIST_NOUN = 'Artist'
export const MIXES_NOUN = 'Mixes Tag'
export const STEMS_NOUN = 'Stems Tag'
export const SEARCH_SOURCE = 'Search'
